import { render } from "./daoruCustomer.vue?vue&type=template&id=71cefb11&scoped=true"
import script from "./daoruCustomer.vue?vue&type=script&lang=js"
export * from "./daoruCustomer.vue?vue&type=script&lang=js"

import "./daoruCustomer.vue?vue&type=style&index=0&id=71cefb11&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cefb11"]])

export default __exports__